import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import EgyptMofaMain from "./EgyptMofaMain";
const EgyptMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <EgyptMofaMain />{" "}
    </div>
  );
};

export default EgyptMofa;
